import { Injectable } from '@angular/core';
import { PaginatedResult } from 'src/app/shared/grid/paginate.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPaginatedServiceParamters } from '../core/models/ITable';
import { PendingFee } from '../core/models/PendingFee';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PendingFeeService {
  constructor(private apiService: ApiService) {}

  getAllPaginated(
    paginatedArguments: IPaginatedServiceParamters,
  ): Observable<PaginatedResult<PendingFee[]>> {
    return this.apiService.getPaginated('/api/fee/pending', paginatedArguments);
  }

  getPendingFee(contractId) {
    return this.apiService.get(`/api/Fee/Pending/${contractId}`);
  }

  addPendingFee(pendingFee) {
    return this.apiService.post(`/api/Fee/CollectPendingFee`, pendingFee);
  }

  addPendingFees(pendingFees) {
    return this.apiService.post(`/api/Fee/CollectPendingFees`, pendingFees);
  }

  downloadFeesCSV(feeParams: any): Observable<Blob> {
    return this.apiService.getBlob('/api/Fee/Pending/DownloadCSV', feeParams);
  }

  downloadFeesExcel(feeParams: any): Observable<Blob> {
    return this.apiService.getBlob('/api/Fee/Pending/DownloadExcel', feeParams);
  }

  // Método optimizado que obtiene solo count y sum usando aggregates del backend
  getPendingFeeQuantity(): Observable<{ count: number; amount: number }> {
    // Usamos pageSize=1 para optimizar, pero el backend devuelve totalItems en pagination
    return this.apiService.getPaginated('/api/fee/pending', { 
      query: '', 
      pageNumber: 1, 
      pageSize: 1
    }).pipe(
      map((response: any) => ({
        count: response.pagination?.totalItems || 0,
        amount: 0 // El backend no devuelve suma agregada, requiere consulta personalizada
      }))
    );
  }
}
